import APIClient from '../../Services/AxiosClient';
import { URL_ENDPOINTS } from '../../Utils/EndPoints';

export const fetchAvailableAnchorShipments = async (queryPayload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.LOAD?.ASSIGNEDSHIPMENTS,
      method: 'get',
      query: queryPayload?.payload,
    });
    queryPayload?.callback && queryPayload?.callback(response);
    return response;
  } catch (err) {
    return null;
  }
};
